import { render, staticRenderFns } from "./IntegrationSettings.vue?vue&type=template&id=a1ff14f2"
import script from "./IntegrationSettings.vue?vue&type=script&lang=js"
export * from "./IntegrationSettings.vue?vue&type=script&lang=js"
import style0 from "./IntegrationSettings.vue?vue&type=style&index=0&id=a1ff14f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports